import { Gender } from '@/types'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

export type GenderSwitchProps = {
  label?: string
  labelClassName?: string
  className?: string
  value: any
  setValue: (gender: Gender) => void
  buttonClassName?: string
  selectedButtonClassName?: string
  disabled?: boolean
}

export const GenderSwitch = ({
  label,
  labelClassName,
  className,
  value,
  setValue,
  buttonClassName,
  selectedButtonClassName,
  disabled,
}: GenderSwitchProps) => {
  const { t } = useTranslation()

  const [showDisabledMessage, setShowDisabledMessage] = useState<boolean>(false)

  return (
    <div className={`flex flex-col gap-y-2`}>
      {label && (
        <span className={`text-white text-sm font-semibold ${labelClassName ? labelClassName : ''}`}>{label}</span>
      )}
      {disabled && showDisabledMessage && (
        <span className="text-xs text-white">Please contact support to change your account's gender setting.</span>
      )}
      <div
        className={`rounded-full border max-w-[354px] h-[50px] border-primary-400 flex ${className ? className : ''}`}
      >
        <button
          type="button"
          className={`flex-1 rounded-full ${buttonClassName ? buttonClassName : ''} ${
            value === Gender.MALE ? `bg-primary-500 ${selectedButtonClassName ? selectedButtonClassName : ''}` : ''
          } ${disabled ? 'opacity-50 cursor-not-allowed' : ''} text-[13px] text-white font-medium`}
          onClick={() => {
            if (disabled) {
              setShowDisabledMessage(true)
              return
            }
            setValue(Gender.MALE)
          }}
        >
          {t('common.man')}
        </button>

        <button
          type="button"
          className={`flex-1 rounded-full ${buttonClassName ? buttonClassName : ''} ${
            value === Gender.FEMALE ? `bg-primary-500 ${selectedButtonClassName ? selectedButtonClassName : ''}` : ''
          } ${disabled ? 'opacity-50 cursor-not-allowed' : ''} text-[13px] text-white font-medium`}
          onClick={() => {
            if (disabled) {
              setShowDisabledMessage(true)
              return
            }
            setValue(Gender.FEMALE)
          }}
        >
          {t('common.woman')}
        </button>
      </div>
    </div>
  )
}
